import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from '@/intl'
import { usePaymentContext } from '@/scopes/payment/domain/PaymentContext'
import { AmountType, AmountTypeValues, PaymentScopePageValues } from '@/scopes/payment/domain/types'
import { formatPaymentDueDateLabel } from './formatPaymentDueDate'
import styles from './PaymentReminders.module.css'

interface RemainingDepositRowProps {
  remainingDeposit: number
  dueDate?: string
  amountType?: AmountType
}

export function RemainingDepositRow({ remainingDeposit, dueDate, amountType }: RemainingDepositRowProps) {
  const { scope } = usePaymentContext()
  const intl = useIntl()

  if (
    scope === PaymentScopePageValues.MANDATORY_PAYMENT
    && amountType !== AmountTypeValues.MIN_DEPOSIT
  ) {
    return null
  }

  const isCustomPartialOnly
    = amountType === AmountTypeValues.MIN_DEPOSIT && scope === PaymentScopePageValues.PAYMENT

  if (isCustomPartialOnly) {
    return null
  }

  if (!dueDate || remainingDeposit <= 0) {
    return null
  }

  return (
    <div className={styles.row}>
      <Typography variant="body-m-bold-tight">
        {intl.formatMessage({
          id: 'payment_scope_remaining_deposit_label',
          defaultMessage: 'Remaining deposit',
        })}
        {' '}
        {formatPaymentDueDateLabel(intl, dueDate)}
      </Typography>
      <Typography variant="body-m-bold-snug">{intl.formatCurrency(remainingDeposit)}</Typography>
    </div>
  )
}

interface FullPaymentReminderRowProps {
  remainingTotalAmount: number
  fullPaymentDueDate?: string
}

export function FullPaymentReminderRow({ remainingTotalAmount, fullPaymentDueDate }: FullPaymentReminderRowProps) {
  const intl = useIntl()

  if (!fullPaymentDueDate || remainingTotalAmount <= 0) {
    return null
  }

  return (
    <div className={styles.row}>
      <Typography variant="body-m-regular-snug">
        {intl.formatMessage(
          {
            id: 'payment_scope_remaining_balance_label',
            defaultMessage: 'Remaining balance',
          },
        )}
        {' '}
        {formatPaymentDueDateLabel(intl, fullPaymentDueDate)}
      </Typography>
      <Typography variant="body-m-regular-snug">{intl.formatCurrency(remainingTotalAmount)}</Typography>
    </div>
  )
}
